// src/redux/addressSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import AddressManager from '../services/dashboard/AddressManager';

export const fetchUserAddress = createAsyncThunk('address/fetchUserAddress', async (userId, thunkAPI) => {
    try {
      const response = await AddressManager.getAddress(userId);
      return response; // Assuming it returns a wrapped response with responseData
    } catch (error) {
      if (error.response && error.response.status === 404) {
        // No address found — treat as a valid (non-error) case
        return { responseData: null };
      }
      return thunkAPI.rejectWithValue(error.response?.data?.responseMessage || "Failed to fetch address");
    }
  });

  // Add this to addressSlice.js
export const addUserAddress = createAsyncThunk(
  'address/addUserAddress',
  async ({ userId, payload }, thunkAPI) => {
    try {
      const response = await AddressManager.addOrUpdateAddress(userId, payload);
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.message || 'Failed to save address');
    }
  }
);


const addressSlice = createSlice({
  name: 'address',
  initialState: {
    address: null,
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserAddress.fulfilled, (state, action) => {
        state.address = action.payload.responseData;
        state.status = 'succeeded';
      })
      .addCase(fetchUserAddress.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchUserAddress.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(addUserAddress.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(addUserAddress.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.address = action.payload;
      })
      .addCase(addUserAddress.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Address creation failed';
      });
  },
});

export default addressSlice.reducer;
